VIV.behaviours.docblock = (function () {

    const attach = function (context) {
        const docblocks = context.querySelectorAll('.docblock');

        if (docblocks.length === 0) {
            return;
        }

        hljs.highlightAll();

        const showAllDocs = document.querySelector('.showAllDocs');
        const hideAllDocs = document.querySelector('.hideAllDocs');

        showAllDocs.addEventListener('click', function () {
            showAllDocs.style.display = 'none';
            hideAllDocs.style.display = 'block';
            document.querySelectorAll('.behaviourShowDoc').forEach((element) => {
                if (!element.classList.contains('docblock__showDocs--active')) {
                    element.click();
                }
            });
        });

        hideAllDocs.addEventListener('click', function () {
            hideAllDocs.style.display = 'none';
            showAllDocs.style.display = 'block';
            document.querySelectorAll('.docblock__showDocs--active').forEach((element) => {
                element.click();
            });
        });

        context.querySelectorAll('.docblock').forEach(block => {
            const buttonShowDoc = block.querySelector('.behaviourShowDoc');
            const codeWrapper = block.querySelectorAll('.docblock__code');
            const docsWrapper = block.querySelectorAll('.docblock__docs');

            if (!buttonShowDoc) {
                return;
            }

            initTabs(block);

            if (codeWrapper.length === 0 && docsWrapper.length === 0) {
                buttonShowDoc.parentElement.removeChild(buttonShowDoc);
            }

            buttonShowDoc.addEventListener('click', () => {
                const active = buttonShowDoc.classList.toggle('docblock__showDocs--active');
                buttonShowDoc.innerText = active
                    ? buttonShowDoc.getAttribute('data-text-hide')
                    : buttonShowDoc.getAttribute('data-text-show');


                codeWrapper.forEach(code => code.classList.toggle('active'));
                docsWrapper.forEach(doc => doc.classList.toggle('active'));
            });
        });
    }

    const initTabs = function (block) {
        const tabs = block.querySelectorAll('.docblock__tab');
        const header = block.querySelector('.docblock__header');
        tabs.forEach(tab => {
            const title = tab.getAttribute('data-title');
            const link = document.createElement('a');
            link.innerText = title;
            link.addEventListener('click', () => {
                tabs.forEach(tab => {
                    tab.classList.remove('docblock__tab--active');
                });
                tab.classList.add('docblock__tab--active');
                return false;
            });
            header.append(link);

        });
    }

    return {
        attach: attach
    }
})();
